 <div *ngIf="showPromoBanner"
      class="v2-h-64px v2-top-0 fixed z-index-highest full-width text-center flex-row-center-center label-1 bg-blue-grey-9 text-white-high-emphasis">
   <img src="/assets/v2-icons/time.svg"
        class="v2-margin-8px-r" /> Limited time offer:&nbsp;<a routerLink="/a/sign-up"
      class="text-primary">{{ promoBannerMessage }}</a>

   <span class="color-green-grey-2 pointer v2-right-0 body-1 absolute"
         [class.hide]="md"
         ngClass="v2-padding-5-h"
         (click)="closePromoBanner()">&times;</span>
 </div>
